var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkPlayed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(79.215688%,92.156863%,98.823529%)",
      fillOpacity: 1
    },
    d: "M 24 12 C 24 18.628906 18.640625 24 12 24 C 5.359375 24 0 18.628906 0 12 C 0 5.371094 5.378906 0 12 0 C 18.621094 0 24 5.378906 24 12 Z M 24 12 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,50.980395%,80.392158%)",
      fillOpacity: 1
    },
    d: "M 16.800781 8.601562 L 10.628906 14.761719 L 7.871094 12 C 7.519531 11.660156 6.949219 11.660156 6.601562 12 C 6.25 12.351562 6.25 12.929688 6.601562 13.28125 L 9.988281 16.671875 C 10.160156 16.839844 10.390625 16.941406 10.628906 16.941406 C 10.871094 16.941406 11.101562 16.839844 11.269531 16.671875 L 18.070312 9.871094 C 18.421875 9.511719 18.421875 8.941406 18.070312 8.601562 C 17.71875 8.25 17.148438 8.25 16.800781 8.601562 Z M 16.800781 8.601562 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkPlayed);
export default __webpack_public_path__ + "static/media/mark-played.12ff9acde0233bd0841e9c2a7d670f54.svg";
export { ForwardRef as ReactComponent };